export default __webpack_public_path__ + "static/media/icomoon.9a6e1b26.ttf";